/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Care_Log_Quarantine_NoteInputs */

const vi_trace_care_log_quarantine_note = /** @type {(inputs: Trace_Care_Log_Quarantine_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu ý cách ly`)
};

/**

* @param {Trace_Care_Log_Quarantine_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_care_log_quarantine_note = /** @type {((inputs?: Trace_Care_Log_Quarantine_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Care_Log_Quarantine_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_care_log_quarantine_note(inputs)
});